import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  // recvCode: {
  //     name: "",
  //     label: "",
  //     type: "text",
  //     errorMsg: "",
  // },
  lineNo: {
    name: "lineNo",
    label: "Line No",
    type: "number",
    // errorMsg: "",
    required: true,
    disabled: true,
  },
  // poNumber: {
  //     name: "",
  //     label: "",
  //     type: "text",
  //     errorMsg: "",
  // },
  // extPONumber: {
  //     name: "",
  //     label: "",
  //     type: "text",
  //     errorMsg: "",
  // },
  poLineNo: {
    name: "poLineNo",
    label: "Po Line No",
    type: "number",
  },
  asnLineNo: {
    name: "asnLineNo",
    label: "ASN Line No",
    type: "number",
  },
  returnCode: {
    name: "returnCode",
    label: "Return Code",
    type: "text",
  },
  // vendorCode: {
  //     name: "vendorCode",
  //     label: "Vendor Code",
  //     type: "text",
  //     errorMsg: "",
  // },
  skuCode: {
    name: "skuCode",
    label: "SKU Code",
    type: "select",
    errorMsg: "SKU code is required",
    required: true,
    editable: false,
  },
  packType: {
    name: "packType",
    label: "Pack Type",
    type: "text",
    // errorMsg: "Pack type is required",
    // required: true,
    disabled: true,
  },
  vDONo: {
    name: "vDONo",
    label: "DO No",
    type: "text",
    errorMsg: "DO No is required",
    required: true,
  },
  vInvNo: {
    name: "vInvNo",
    label: "Invoice No",
    type: "text",
    errorMsg: "Invoice no is required",
    required: true,
  },
  recvWh: {
    name: "recvWh",
    label: "Receiving Warehouse",
    type: "select",
    required: true,
    errorMsg: "Receiving warehouse is required.",
  },
  recvZone: {
    name: "recvZone",
    label: "Receiving Zone",
    type: "select",
    required: true,
    errorMsg: "Receiving zone is required.",
  },
  recvLocation: {
    name: "recvLocation",
    label: "Receiving Location",
    type: "select",
    required: true,
    errorMsg: "Receiving location is required.",
  },
  cartonID: {
    name: "cartonID",
    label: "Carton ID",
    type: "text",
  },
  oln: {
    name: "oln",
    label: "OLN",
    type: "text",
  },
  mln: {
    name: "mln",
    label: "MLN",
    type: "text",
  },
  customsLot: {
    name: "customsLot",
    label: "Customs Lot",
    type: "text",
  },
  manualLot: {
    name: "manualLot",
    label: "Manual Lot",
    type: "text",
  },
  manufacturingDate: {
    name: "manufacturingDate",
    label: "Manufacturing Date",
    type: "date",
  },
  expiryDate: {
    name: "expiryDate",
    label: "Expiry Date",
    type: "date",
    // default: 0
  },
  qtyExpected: {
    name: "qtyExpected",
    label: "Quantity Expected",
    type: "number",
  },
  qtyReceived: {
    name: "qtyReceived",
    label: "Quantity Received",
    type: "number",
    required: true,
  },
  uom: {
    name: "uom",
    label: "UOM",
    type: "select",
    required: true,
    errorMsg: "UOM is required",
  },
  quantity: {
    name: "quantity",
    label: "Quantity",
    type: "number",
    disabled: true,
    size:3
  },
  baseUOM: {
    name: "baseUOM",
    label: "Base UOM",
    type: "text",
  },
  condition: {
    name: "condition",
    label: "Condition",
    type: "select",
  },
  // cases: {
  //     name: "cases",
  //     label: "Cases",
  //     type: "number",
  // },
  // innerPack: {
  //     name: "innerPack",
  //     label: "Inner Pack",
  //     type: "number",
  // },
  // pallet: {
  //     name: "pallet",
  //     label: "Pallet",
  //     type: "number",
  // },
  // grossWeight: {
  //     name: "grossWeight",
  //     label: "Gross Weight",
  //     type: "number",
  // },
  // netWeight: {
  //     name: "netWeight",
  //     label: "Net Weight",
  //     type: "number",
  // },
  // weightUOM: {
  //     name: "weightUOM",
  //     label: "Weight UOM",
  //     type: "text",
  // },
  // cubic: {
  //     name: "cubic",
  //     label: "Cubic",
  //     type: "number",
  // },
  // cubicUOM: {
  //     name: "cubicUOM",
  //     label: "Cubic UOM",
  //     type: "text",
  // },
  // computation: {
  //     name: "computation",
  //     label: "Computation",
  //     type: "text",
  // },
  currencyCode: {
    name: "currencyCode",
    label: "Currency Code",
    type: "text",
    disabled:true
  },
  unitPrice: {
    name: "unitPrice",
    label: "Unit Price",
    type: "number",
  },
  remark: {
    name: "remark",
    label: "Remark",
    type: "text",
    size:3
  },

  btnApplyDO: {
    name: "vDONo",
    label: "Apply DO",
    type: "button",
    size: 2,
  },
  btnApplyInv: {
    name: "vInvNo",
    label: "Apply Inv",
    type: "button",
    size: 2,
  },
  expiryDateCtrl: {
    name: "expiryDateCtrl",
    label: "Expiry Date Control",
    type: "switch",
  },
  mlnCtrl: {
    name: "mlnCtrl",
    label: "Manufacturing Lot No Control",
    type: "switch"
  },
  manDateCtrl: { name: "manDateCtrl", label: "Manufacturing Date Control", type: "switch" },
  manualLotCtrl: { name: "manualLotCtrl", label: "Manual Lot No Control", type: "switch" },
  inbSerialNbrCtrl: { name: "inbSerialNbrCtrl", label: "Inbound Serial No Control", type: "switch" },
  serialNumbers: { name: "serialNumbers", label: "Serial Numbers", type: "multi-select", xs: 12 },
};

const {
  status,
  lineNo,
  poLineNo,
  asnLineNo,
  returnCode,
  skuCode,
  packType,
  vDONo,
  vInvNo,
  recvWh,
  recvZone,
  recvLocation,
  cartonID,
  oln,
  mln,
  customsLot,
  manualLot,
  manufacturingDate,
  expiryDate,
  qtyExpected,
  qtyReceived,
  uom,
  quantity,
  currencyCode,
  unitPrice,
  remark,
  expiryDateCtrl,
  manDateCtrl,
  manualLotCtrl,
  mlnCtrl,
  condition,
  inbSerialNbrCtrl,
  serialNumbers
} = formField;

// export const detailRender=[
//     [lineNo, status],
//     [skuCode, packType],
//     [vDONo,btnApplyDO, vInvNo,btnApplyInv],
//     [{ type: "line" }],
//     [oln],
//     [recvWh, recvZone],
//     [recvLocation],
//     [{ type: "line" }],
//     [mln, cartonID],
//     [manufacturingDate, expiryDate],
//     [manualLot, customsLot],
//     [{ type: "line" }],
//     [qtyReceived, uom],
//     [quantity, unitPrice],
//     [currencyCode, remark]
// ]

export const detailRender = [
  [lineNo, skuCode, packType, status],
  [vDONo, vInvNo, mln, cartonID],
  // [{ type: "line" }],
  [oln, recvWh, recvZone, recvLocation],
  // [{ type: "line" }],
  [manufacturingDate, expiryDate, manualLot, customsLot],
  // [{ type: "line" }],
  [qtyReceived, uom, currencyCode, unitPrice],
  [quantity,condition, remark],
  [serialNumbers],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  //---------------- detail ---------------
  [poLineNo.name]: Yup.number().typeError("Please enter number only"),
  [asnLineNo.name]: Yup.number().typeError("Please enter number only"),
  [returnCode.name]: Yup.string().nullable().max(20),
  // [skuCode.name]: Yup.string().max(50).required(skuCode.errorMsg),
  // [packType.name]: Yup.string().max(10).required(packType.errorMsg),
  [skuCode.name]: Yup.string().nullable().max(50).required(skuCode.errorMsg),
  // [packType.name]: Yup.string().nullable().max(10).required(packType.errorMsg),
  [expiryDateCtrl.name]: Yup.boolean(),
  [manDateCtrl.name]: Yup.boolean(),
  [manualLotCtrl.name]: Yup.boolean(),
  [inbSerialNbrCtrl.name]: Yup.boolean(),
  [mlnCtrl.name]: Yup.boolean(),
  [vDONo.name]: Yup.string().nullable().max(20).required(vDONo.errorMsg),
  [vInvNo.name]: Yup.string().nullable().max(20).required(vInvNo.errorMsg),
  [recvWh.name]: Yup.string().nullable().max(20).required(recvWh.errorMsg),
  [recvZone.name]: Yup.string().nullable().max(20).required(recvZone.errorMsg),
  [recvLocation.name]: Yup.string().nullable().max(20).required(recvLocation.errorMsg),
  [cartonID.name]: Yup.string().nullable().max(20),
  [oln.name]: Yup.string().nullable().max(20),
  [mln.name]: Yup.string()
    .nullable()
    .max(20)
    .when("mlnCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [customsLot.name]: Yup.string().nullable().max(20),
  [manualLot.name]: Yup.string()
    .nullable()
    .max(20)
    .when("manualLotCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [manufacturingDate.name]: Yup.string()
    .nullable()
    .when("manDateCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [expiryDate.name]: Yup.string()
    .nullable()
    .when("expiryDateCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  //.min(today, minDateMessage)
  //.max(maxDate, maxDateMessage),
  //.transform((value, originalValue) => parse(originalValue, 'dd-MM-yyyy', new Date())),
  //.typeError("Please enter valid date"),
  [qtyExpected.name]: Yup.number().typeError("Please enter number only"),
  [qtyReceived.name]: Yup.number().min(1).typeError("Please enter number only"),
  [uom.name]: Yup.object()
    .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
    .nullable()
    .required(uom.errorMsg),
  [quantity.name]: Yup.number().min(0).typeError("Please enter number only"),
  // [baseUOM.name]: Yup.string().nullable().max(10),
  // [cases.name]: Yup.number().typeError("Please enter number only"),
  // [innerPack.name]: Yup.number().typeError("Please enter number only"),
  // [pallet.name]: Yup.number().typeError("Please enter number only"),
  // [grossWeight.name]: Yup.number().min(0).typeError("Please enter number only"),
  // [netWeight.name]: Yup.number().min(0).typeError("Please enter number only"),
  // [weightUOM.name]: Yup.string().nullable().max(10),
  // [cubic.name]: Yup.number().min(0).typeError("Please enter number only"),
  // [cubicUOM.name]: Yup.string().nullable().max(10),
  // [computation.name]: Yup.string().nullable().max(25),
  [currencyCode.name]: Yup.string().nullable().max(10),
  [unitPrice.name]: Yup.string().nullable().max(20),
  //[expiryDate.name]:Yup.string().nullable().required().when
  [serialNumbers.name]: Yup.array()
    .of(
      Yup.object().shape({
        serialNumber: Yup.string()
          .required("Serial Number is required")
          .max(50, "Serial Number cannot be longer than 50 characters"),
      })
    )
    .when("inbSerialNbrCtrl", {
      is: true,
      then: (schema) => schema.required().min(1, "At least one serial number is required"),
    }),
});
